import { render, staticRenderFns } from "./AccountAuditLog.vue?vue&type=template&id=32ae4998&"
import script from "./AccountAuditLog.vue?vue&type=script&lang=js&"
export * from "./AccountAuditLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports